import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { useModal } from '../hooks/modal'
import { useDeleteRequest } from '../hooks/request'
import { NOMENCLATURE_DETAIL, domain } from '../urls'
import { format } from '../utils/number'
import { measurement } from '../utils/position'
import Button from './common/Button'
import ReactModal from './common/ReactModal'

import ProductUpdate from './ProductUpdate'
import { getCurrency } from '../utils/types'

export default function NomenclatureHomeItem({ categoryList, item, brandList, index, products }) {
    // State variables for the image modal
    const [isModalOpen, setIsModalOpen] = useState(false)

    // Style definitions for images
    const defaultImageStyle = {
        width: '40px',
        height: '40px',
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#999',
        fontSize: '12px',
        textAlign: 'center',
        cursor: 'pointer'
    }

    const imageStyle = {
        width: '40px',
        height: '40px',
        objectFit: 'cover',
        borderRadius: '4px',
        border: '1px solid #ddd',
        cursor: 'pointer'
    }

    const productRemove = useDeleteRequest({ url: NOMENCLATURE_DETAIL.replace('{id}', item?.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            await products.request()
        }
    }

    const [showUpdateModal, setShowUpdateModal] = useModal(<ProductUpdate products={products} categoryList={categoryList} brandList={brandList} item={item} hideModal={() => setShowUpdateModal()} />, styles.modal)

    return (
        <>
            <tr className="is-size-6" key={item.id}>
                <td className="is-size-6">{index + 1}</td>
                <td className="is-size-6 is-capitalized">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {item?.selectProducts?.image ? (
                            <img
                                onClick={() => setIsModalOpen(true)}
                                src={domain + item?.selectProducts?.image}
                                alt={item.name}
                                style={imageStyle}
                            />
                        ) : (
                            <div
                                onClick={() => setIsModalOpen(true)}
                                style={defaultImageStyle}
                            >
                                <ion-icon name="image-outline" />

                            </div>
                        )}
                        <span>{item?.selectProducts?.name}</span>
                    </div>
                </td>
                <td className="is-size-6">{item?.selectSupplier?.name ? item?.selectSupplier?.name : '\tНе выбирайте'}</td>
                <td className="is-size-6">{item?.selectProducts?.code}</td>

                <td className="is-size-6" style={{ textWrap: 'nowrap' }}>
                    {format(item?.price)}
                </td>

                <td className="is-size-6" style={{ textWrap: 'nowrap' }}>
                    {format(item?.priceTransfer)}
                </td>

                <td className="is-size-6" style={{ textWrap: 'nowrap' }}>
                    {format(item?.priceSale)}
                </td>

                <td className="is-size-6">{getCurrency(item?.paymentType)}</td>

                <td className="is-size-6">
                    {item?.count} {measurement(item?.measurement)}
                </td>

                <td className="">
                    <div className="is-pulled-right is-flex is-flex-wrap-nowrap">
                        <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small" icon="pencil-outline" />
                        <Button onClick={onDelete} className="button is-danger is-outlined is-small" icon="trash" />
                    </div>
                </td>
            </tr>

            {/* Image Modal */}
            <ReactModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                style={{
                    content: {
                        maxWidth: '500px',
                        margin: 'auto',
                        padding: '20px',
                    },
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    {item?.selectProducts?.image ? (
                        <img
                            src={domain + item?.selectProducts?.image}
                            alt={item.name || 'Product image'}
                            style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain' }}
                        />
                    ) : (
                        <div style={{
                            padding: '20px',
                            textAlign: 'center',
                            color: '#999',
                            fontSize: '16px',
                        }}>
                            <i className="fas fa-image" style={{ fontSize: '48px', marginBottom: '10px' }} />
                            <p>📷 Изображение отсутствует.</p>
                        </div>
                    )}
                </div>
            </ReactModal>
        </>
    )
}

const styles = StyleSheet.create({
    tr: { ':nth-child(1n) > td': { lineHeight: 1 } },
    center: { display: 'flex', alignItems: 'center' },
    td1: { display: 'flex', alignItems: 'center', gap: '5px', lineHeight: 1, cursor: 'pointer' },
    td1Img: { width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' },
    td1Right: {},
    td1RightTitle: { fontFamily: 'GilroySemi', color: '#333333', lineHeight: '19px' },
    td1RightSubtitle: { marginTop: '1px', fontFamily: 'Gilroy', fontSize: '14px', color: 'rgba(51, 51, 51, 0.7)', lineHeight: '16px' },
    industries: { display: 'flex', whiteSpace: 'nowrap', flexWrap: 'wrap' },
    modal: { width: 1000 },
})
